import React, { useState, useEffect } from "react";
import BreadCrumb from "../BreadCrumb";
import Layout from "../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../common/Loader";
import {
  fetchBranchList,
} from "../../redux/actions/feesActions";
import DynamicFilters from '../DynamicFilters'
import { useForm , Controller } from "react-hook-form";
import ReactSelect from 'react-select';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import InfiniteScroll from "react-infinite-scroll-component";
import { Form, Row, Col, Card, Button, Table, Badge } from "react-bootstrap";
import { customFormatOptions } from "../../common/converters";
import CreateNotification from "./createNotification";
import { BRANCH, CLASS_GROUP, CLASS_NAME ,STUDENTS_GROUP} from "../constants";
import { createNotificationAction, listAction ,studentNofificationAction ,resetNotificationAction, NOTIFICATION_LIST} from "../../redux/actions/notificationAction";
import DataTable from "../Tables/DataTable";
import moment from "moment";
import { getReqValue, STUDENT } from "../../common/constants";
import NotificationTable from "./notificationTable";
import AgGridTable from "../Tables/agGridTable";
import CustomTooltip from './customTooltip.jsx';
import { STUDENT_NOTIFICATION_LIST } from "../../redux/actions/studentActions";

const Notification = (props) => {
  const dispatch = useDispatch();
  const { loader, feeDetails, branchList, feeStructure ,branchLevelDetails} = useSelector(
    (state) => state.fees
  );
  const { userDetails  } = useSelector((state) => state.user);
  const { loader: notificationLoader , notificationsList,pagination } = useSelector((state) => state.notification);
  const [currentPageLoader, setCurrentPageLoader] = useState(false);
  const [updatedFees, setUpdatedFees] = useState({});
  const [fees, setFees] = useState(feeDetails);
  const [branchData, setBranchData] = useState([]);
  const [show, setShow] = useState(false);
  const [sideMenu, setSideMenu] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [filterLoader, setFilterLoader] = useState(false);
  const [branch, setBranch] = useState([]);
  const [classGroup, setClassGroup] = useState([]);
  const [classRoom, setClassRoom] = useState([]);
  const [year, setYear] = useState([]);
  const [customRange, setCustomRange] = useState({
    startDate: moment().startOf('year'),
    endDate: moment()
  });
  const [hasMore, setHasMore] = useState(true);
  const [agGridRef, setAgGridRef] = useState(null);
  const [rowNode, setRowNode] = useState(null);
  const onSideMenu = (value) => {
    setSideMenu(value);
  };
  
  const validationSchema = Yup.object().shape({
    branchName: Yup.string().required("Branch Name is required"),
    playSchool: Yup.string().required("Play School is required"),
    nursery: Yup.string().required("Nursery is required"),
    jrKg: Yup.string().required("Jr.Kg Attend is required"),
    srKg: Yup.string().required("Sr.Kg is required"),
  });
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      taxBenfits: "false",
      // city
    },
    resolver: yupResolver(validationSchema),
  });
  useEffect(async () => {
    // await dispatch(listAction())
    await dispatch(resetNotificationAction())
    await dispatch(fetchBranchList());
    if(userDetails.role === STUDENT){
      await dispatch(studentNofificationAction({
        StudentId: userDetails.StudentId,
        page: 1,
        perPage: (pagination.perPage || 20)
      }))
    }
    
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  
  useEffect(async () => {
    setBranchData(customFormatOptions(branchList,'id','name'));
  }, [branchList]);
  
  const create = async (data) => {
        await dispatch(createNotificationAction(data));
      setShow(false);
  };

  const closeModal = () => {
    setShow(false);
  };
  const createClassRoom = async () => {
    setShow(true);
    setSelectedEvent(CLASS_NAME);

  };
  const createStudentsGroup = async () => {
    setShow(true);
    setSelectedEvent(STUDENTS_GROUP);
  };
 
  const classGroupAction =async() => {
    setShow(true);
    setSelectedEvent(CLASS_GROUP);

  }
  const columnDefs = [
    {
      headerName: "Notifiable Level",
      field: "notifiableType",
      // maxWidth:150
    },
    {
      headerName: "Notification Type",
      field: "notificationType",
      maxWidth:200
    },
    { headerName: "Subject", field: "subject" },
    { headerName: "Message", field: "content" ,tooltipField: 'content',
    tooltipComponentParams: { color: '#ececec' } },
    {
      headerName: "ClassGroup",
      field: "ClassGroupName",
      maxWidth:150
    },
    {
      headerName: "ClassRoom",
      field: "ClassRoomName",
      maxWidth:150
    },
    {
      headerName: "Student Name",
      field: "StudentName",
    },
    
    { headerName: "Created At", field: "createdAt" },
  ];
  const headerList = [
    {
      name: "Notifiable Level",
      key: "notifiableType",
    },
    {
      name: "Notification Type",
      key: "notificationType",
    },
    {
      name: "ClassGroup Name",
      key: "ClassGroupName",
    },
    {
      name: "ClassRoom Name",
      key: "ClassRoomName",
    },
    {
      name: "Student Name",
      key: "StudentName",
    },
    { name: "Subject", key: "subject" },
    { name: "Message", key: "content" },
    { name: "Created At", key: "createdAt" },
    
  ];
  const studentColumnDefs = [
    {
      headerName: "Notifiable Level",
      field: "notifiableType",
      // maxWidth:150
    },
    {
      headerName: "Notification Type",
      field: "notification_type",
      maxWidth:200
    },
    { headerName: "Subject", field: "subject" },
    { headerName: "Message", field: "content" ,tooltipField: 'content',minWidth:400,
      tooltipComponentParams: { color: '#ececec' } },
    {
      headerName: "ClassGroup",
      field: "ClassGroupName",
      maxWidth:150
    },
    {
      headerName: "ClassRoom",
      field: "ClassRoomName",
      maxWidth:150
    },
    { headerName: "Created At", field: "createdAt" },
    
  ];
  const nestedHeader = [
    { name: "Message", key: "content" },
  ];
  
  

  const DynamicFiltersProps = [
    {
      type: "Select",
      placeholder: "Select Year",
      state: year,
      mappingKey: "year",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2",
      label: "Year",
    },
    {
      type: "Select",
      placeholder: "Select Branch",
      state: branch,
      mappingKey: "branch",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2",
      label: "Branch",

    },
    {
      type: "Select",
      placeholder: "Select ClassGroup",
      state: classGroup,
      mappingKey: "classGroup",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2",
      label: "Class Group",
    },
    {
      type: "Select",
      placeholder: "Select ClassRoom",
      state: classRoom,
      mappingKey: "classRoom",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "ClassRoom",
    },
    {
      type: "DateRangePicker",
      placeholder: "Select Date Range",
      state: customRange,
      mappingKey: "customDate",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "Select Date Range",
      disabled: year.length === 0
    },
    
  ];
  
  const DynamicFiltersOptions = {
    branchOptions: [],
    classGroupOptions: [],
    classRoomOptions: [],
    yearOptions: [],
  };

  const hierarchyLevel = ["branch", "classGroup", "classRoom"];
  const hierarchyApiCalls = [
    {
      optionsMappingKey: "branch",
      UrlName: "branch",
    },
    {
      optionsMappingKey: "year",
      UrlName: "year",
    },
  ];
  const hierarchyFilterApi = "branchFilter";
  const onRefresh = () => {
    reloadData();
  };
  const reloadData = () => {
    setBranch([]);
    setClassGroup([]);
    setClassRoom([]);
    setYear([]);
     dispatch(resetNotificationAction())
  };
  const updateState = (params) => {
    let keysLength = Object.keys(params).length;
    if (params.hasOwnProperty("branch")) {
      setBranch(params[`branch`]);
    }
    if (params.hasOwnProperty("classGroup")) {
      setClassGroup(params[`classGroup`]);
    }
    if (params.hasOwnProperty("classRoom")) {
      setClassRoom(params[`classRoom`]);
    }
    if (params.hasOwnProperty("year")) {
      setYear(params[`year`]);
      setCustomRange({
        startDate: moment([params['year'][0].value]).startOf('year'),
        endDate: moment([params['year'][0].value]).endOf('year')
      })
    }
    if (params.hasOwnProperty("customRange")) {
      setCustomRange(params[`customRange`]);
    }
  };
  const fetchParamsList =  ()=>{
    const params = {
      BranchId: getReqValue(branch),
      ClassGroupId: getReqValue(classGroup),
      ClassRoomId: getReqValue(classRoom),
      year: getReqValue(year),
      startDate: moment(customRange.startDate).format("YYYY-MM-DD"),
      endDate: moment(customRange.endDate).format("YYYY-MM-DD"),
      perPage: pagination.perPage
    };
    return params;
  }
  const fetchNotifications = async(params)=>{
    await dispatch(listAction(params));
  }
  const filterData = async () => {
    await dispatch(resetNotificationAction());
    let reqParams = await fetchParamsList();
    reqParams.page = 1;
    await fetchNotifications(reqParams);
  };
  const openLoader = () => {
    setFilterLoader(true);
  };
  const closeLoader = () => {
    setFilterLoader(false);
  };
  const fetchMoreData =async()=>{
    console.log(pagination)
    // if (studentProfiles.length === pagination.totalItems) {
    if ((pagination.totalPages === 1 || (pagination.totalPages -1) === pagination.currentPage)  ) {
      setHasMore(false)
      return;
    }
    let reqParams = await fetchParamsList();
    reqParams.page = pagination.currentPage + 1;
    await fetchNotifications(reqParams);
  }
  const setGridRefData =(params)=>{
    setAgGridRef(params)
  }
  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader || filterLoader || notificationLoader }>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <CreateNotification
            show={show}
            closeModal={closeModal}
            create={create}
            selectedEvent={selectedEvent}
            branchData={branchData}
          />
          <div class="row filter-block">
            {userDetails.role === STUDENT ? null : (
              <>
                <DynamicFilters
                filtersList={DynamicFiltersProps}
                options={DynamicFiltersOptions}
                hierarchyLevel={hierarchyLevel}
                hierarchyApiCalls={hierarchyApiCalls}
                hierarchyFilterApi={hierarchyFilterApi}
                openLoader={openLoader}
                closeLoader={closeLoader}
                updateParentState={updateState}
                filterData={filterData}
                onReset={onRefresh}
                // onDatepickerChange={this.handleYearData}
                viewType="verticle"
                isFilterButtonDisabled={branch.length === 0 || year.length === 0}
              />
              </>
            )}
          </div>
          { userDetails.role === STUDENT ? null : (
            <>
            <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-10 col-lg-7 col-xl-7">
              <div className="row">
              <div className="col-4">
                  <Button
                      className="btn  app-default-button btn-sm"
                    >
                      Notifications <Badge variant="primary">{pagination.totalItems}</Badge>
                    </Button>
                    
                  </div>
                  <div className="col-8">
                  </div>
                </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-5 col-xl-5">
              <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-2 col-lg-3 col-xl-2">
                  {/* <Button
                    className="btn app-default-button btn btn-primary"
                    type="button"
                    onClick={() => {
                      setShow(true);
                      setSelectedEvent(BRANCH);
                    }}
                  >
                    Branch
                  </Button> */}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-5 col-xl-4">
                  {/* <Button
                    className="btn app-default-button btn btn-primary"
                    type="button"
                    onClick={classGroupAction}
                  >
                    Class Group
                  </Button> */}
                </div>
                
                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-4 col-xl-3">
                  {/* <Button
                    className="btn app-default-button btn btn-primary"
                    type="button"
                    onClick={createClassRoom}
                  >
                    Class Room
                  </Button> */}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-4 col-xl-3">
                  <Button
                    className="btn app-default-button btn btn-primary"
                    type="button"
                    onClick={createStudentsGroup}
                    disabled
                  >
                     Students Group
                  </Button>
                </div>
                
              </div>
            </div>
          </div>
            </>
          )}
          
          <div className="spacer"></div>
          {notificationsList.length > 0 ? (
            <>
            {/* <InfiniteScroll
             dataLength={notificationsList.length}
             next={fetchMoreData}
             hasMore={pagination.totalPages === 1 ? false : hasMore}
             loader={<h4>Loading...</h4>}
             endMessage={
               <div className="alert alert-success text-center">
                 Yay! You have seen it all
               </div>
             }
           >
            <NotificationTable
              header={userDetails.role === STUDENT ? studentHeaderList : headerList}
              data={notificationsList}
              nestedHeader={nestedHeader}
            />
            </InfiniteScroll> */}
            <AgGridTable 
            rowData={notificationsList} 
            columnDefs={userDetails.role === STUDENT ? studentColumnDefs :  columnDefs} 
            defaultColDef={{
            resizable: true,minWidth: 100,
            tooltipComponent: CustomTooltip
            }}
            pagination={pagination}
            // datasource={datasource}
            isPaginationRequired={true}
            actionType={userDetails.role === STUDENT ? STUDENT_NOTIFICATION_LIST : NOTIFICATION_LIST}
            fetchParamsList={fetchParamsList}
            setAgGridRef={setGridRefData}
            tooltipShowDelay={0}
            tooltipHideDelay={60000}
              />
            </>
          ) : (
            <div className="alert alert-success">No Data to view</div>
          )}
        </div>
      </PageLoader>
    </div>
  );
};

export default Notification;
